import React from 'react'
import '../layouts/tachyons/css/tachyons.css';
import '../layouts/custom.css';
import { Title1, Title2, Small, Medium, Tiny} from "./typography"
import { SectionContact, SectionTestimonial, FooterLink, FooterLinkList } from "./section"
import Fade from 'react-reveal/Fade';
import Jello from 'react-reveal/Jello';
import AniLink from 'gatsby-plugin-transition-link/AniLink';
import { withPrefix } from 'gatsby'
import {CopyToClipboard} from 'react-copy-to-clipboard';


class Footer extends React.Component {

    constructor(props) {
      super(props);
      
      this.stateTestimonial = {
        randomNumber: Math.floor(Math.random() * Math.floor(4))
      };

      this.state = {
        visibility: false,
        class: "fw7 o-0 dn copied-container",
        show: true
      };
      this._addClassName = this._addClassName.bind(this);

    }

    _removeClassName() {

      this.setState({
          visibility: false,
          class: "fw3 dn",
          show: false

      })
  }

  _addClassName() {
      this.setState({
          visibility: true,
          class: "fw3 db copied-container",
          show: true
      });
      setTimeout(this._removeClassName.bind(this), 2500);

    }

    render() {   
      const posts = [
        {
          id: 1,
          title: 'Managing Director of Black and Milk Residential Limited',
          description: 'I enjoyed working with Thomas. His designs were sharp and the process is fast and efficient. Thomas is about quick execution, responsive communication and use of best practices. I recommend Thomas for web development.',
          thumb: '/img/anatoly.png',
          fullname: 'Anatoly Alekseev',
        },
        {
          id: 2,
          title: 'CEO at DoubleDot Media Limited',
          description: 'Thomas is always full of creative ideas to improve our designs. I have no issue in recommending him to others.',
          thumb: '/img/simon.png',
          fullname: 'Simon Slade',
         },
         {
          id: 3,
          title: 'Managing Partner at Hacktiv8',
          description: 'I enjoyed working together with Thomas because he brings a perspective of usability that is enlightening and well put together!',
          thumb: '/img/ronald.jpg',
          fullname: 'Ronald Ishak',
         },
         {
          id: 4,
          title: 'Former Director of Mobile at Skillshare',
          description: "Thomas's craft and adaptability allowed us to test new ideas quickly and iterate towards short and long term goals. A real pleasure working together.",
          thumb: '/img/chris.png',
          fullname: 'Chris Boardman',
         },
         ];
         

      return (
        <div>

        <div className={this.state.class}>
            <Fade top duration={300}>
                <div className="copied">
                <Medium>Email: <span class="fw6">hi[at]thebuddyman.com</span> copied to clipboard</Medium>
                </div>
            </Fade>
        </div>

        <Fade duration={1000}>
          <SectionTestimonial className="fr-ns mb4-m fl">
              <div className="tc-ns tl-m mt4-ns mb4-ns mt0-m mb3-m mt3 mb3">
                <img src={withPrefix(posts[this.stateTestimonial.randomNumber].thumb)} className="br-100 h3 w3 dib mb0" alt="avatar"  />
              </div>
              <Small className="pr0 sans-serif mb3 mb3-m tc-ns tl-m center">{posts[this.stateTestimonial.randomNumber].description}</Small>
              <Tiny className="fw6 tc-ns tl-m center">{posts[this.stateTestimonial.randomNumber].fullname}<br/>{posts[this.stateTestimonial.randomNumber].title}</Tiny>
          </SectionTestimonial>
        </Fade>
  
        <Fade duration={1000}>
          <SectionContact className="pv6-ns ph5-m pv5-m pl4 pv4 fr-ns fl w-100">
            <Small className="white mb3 measure-wide w-100-ns w-90">I'm currently accepting new design project. If you are interested in working with me,</Small>
            <Jello count={1} delay={800}>
            <CopyToClipboard 
              text="hi@thebuddyman.com" onClick={this.addClassName}
              onCopy={() => { }}>
              <Title2 className="mb5 white"><span className="white sayhi-link sayhi cursor" onClick={this._addClassName}>Let's chat!</span></Title2>
            </CopyToClipboard>
            </Jello>
            <FooterLink>
              {/*<FooterLinkList><AniLink cover to="/" bg="#C1C1C8" direction="up" duration={0.8} className="white">HOME</AniLink></FooterLinkList>*/}
              {/*<FooterLinkList><AniLink cover to="about" bg="#0F1724" direction="up" duration={0.8} className="white">ABOUT</AniLink></FooterLinkList>*/}
              <FooterLinkList><AniLink cover to="work" bg="#0F1724" direction="up" duration={0.8} className="white">WORK</AniLink></FooterLinkList>
              <FooterLinkList><a className="white" href="https://medium.com/@thomasbudiman" target="_blank">WRITING</a></FooterLinkList>
              {/*<FooterLinkList><AniLink cover to="credits" bg="#0F1724" direction="up" duration={0.8} className="white">CREDITS</AniLink></FooterLinkList>*/}
            </FooterLink>
          </SectionContact>
        </Fade>
  
        </div>
      )
    }
  }
  
  export default Footer